import React from 'react';

interface StepLoaderProps {
  dotCount?: number;
}

export const StepLoader: React.FC<StepLoaderProps> = ({ dotCount = 5 }) => {
  return (
    <div className="step-loader-container">
      {Array.from({ length: dotCount }).map((_, i) => (
        <div
          key={i}
          className="step-dot"
        ></div>
      ))}
    </div>
  );
};
